import { FC } from "react";
import { BoxArrowRight, Envelope, HouseDoor, Layers, Tree } from "react-bootstrap-icons";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

export const BrandMark: FC = () => (
    <img className="brand-mark" src={logo} alt="" />
)

interface SidebarProps {
    hasEditAccess: Boolean,
    onLogout: () => void
}

const navItemClass = ({ isActive }: { isActive: boolean }) => "nav-item" + (isActive ? " active" : "")

const Sidebar: FC<SidebarProps> = ({ hasEditAccess, onLogout }) => {
    return (
        <nav className="sidebar">
            <NavLink to="/interior" className="brand">
                <BrandMark />
                <span className="brand-name">Dwellable</span>
                <span className="brand-tag">Admin</span>
            </NavLink>

            <div className="nav-section">Home questions</div>
            <NavLink to="/interior" className={navItemClass}><HouseDoor size={15} /> Interior</NavLink>
            <NavLink to="/exterior" className={navItemClass}><Tree size={15} /> Exterior</NavLink>
            <NavLink to="/basement" className={navItemClass}><Layers size={15} /> Basement</NavLink>

            <div className="nav-section">Content</div>
            <NavLink to="/newsletters" className={navItemClass}><Envelope size={15} /> Newsletter review</NavLink>

            <div className="sidebar-footer">
                {!hasEditAccess && <span className="chip warn align-self-start">Read-only access</span>}
                <button className="nav-item border-0 bg-transparent text-start" onClick={onLogout}>
                    <BoxArrowRight size={15} /> Log out
                </button>
            </div>
        </nav>
    )
}

export default Sidebar;
